import { WHATSAPP_NUMBER } from "@/lib/api";
import { track } from "@/lib/analytics";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

export default function WhatsAppButton() {
  const { pathname } = useLocation();
  // CollegePage (/college/:slug) renders its own sticky mobile bottom bar with a
  // WhatsApp CTA, so hide the floating FAB on mobile there to avoid overlap.
  const hasMobileStickyBar = /^\/college\/[^/]+/.test(pathname);
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi CollegeUnlock, I would like admission guidance.")}`;
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      onClick={() => track("whatsapp_click", { location: "floating_button" })}
      className={`fixed bottom-6 right-6 z-40 ${hasMobileStickyBar ? "hidden lg:flex" : "flex"} h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-110 hover:shadow-xl`}
    >
      <MessageCircle className="h-7 w-7" fill="white" strokeWidth={1.5} />
    </a>
  );
}
